import React, { Component } from "react";
import { check_it, no_information_found, last_test_version, rolled_back, check, in_date, last_public_release, detail, version_code, version_name, download_it } from "../../../resources/string/strings"
import { ReactComponent as IconLab } from "../../../resources/image/ic_lab.svg";
import Category from "../../util/category";
import Files from "../../util/files";
import Links from "../../util/links";
import { Link } from "react-router-dom";

class Adapter extends Component {
  state = {
    deleteModalShow: false,
  };

  render() {
    const { item } = this.props;

    return (
      <div style={{ marginBottom: 36 }} className="col-12 row mx-auto">
        
        <Category
          className="col-12 ml-0 pl-0"
          categoryId={item.id}
          pictureUrl={item.pictureUrl}
          titleFa={item.titleFa}
          titleEn={item.titleEn}
          showMoreLink={true}
        />

        <div className="app-card col-12 mt-2">

          {item.lastTestRelease !== undefined && item.lastTestRelease !== null &&
            <div>

              <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right", marginBottom: 10 }}>
                <IconLab
                  className="p-0"
                  width="25"
                  height="25"
                />

                <span className="mr-2"> {last_test_version}</span>
              </div>


              <div style={{ textAlign: "right", marginTop: 4 }}>
                <div className="mr-2 " style={{ fontSize: 14, color: "black", textDecoration: "none" }}>
                <span style={{ fontSize: 12, color: "silver"}}>{version_name}: </span>
                {item.lastTestRelease.versionName}
                  <Link target="_blank" to={"/releases/detail?i=" + item.lastTestRelease.id} style={{ fontSize: 11, color: "indianred", marginRight: 10, textDecoration: "none" }}>{detail}</Link>
                </div>

              </div>

              {item.lastTestRelease.versionCode !== undefined && item.lastTestRelease.versionCode !== null && item.lastTestRelease.versionCode !== "" &&
                <div style={{ color: "slateblue", fontSize: 12, textAlign: "right", marginTop: 5 }}>
                  <span style={{ fontSize: 12, color: "silver"}}>{version_code}: </span> {item.lastTestRelease.versionCode}
                </div>
              }

              <div style={{ color: "black", fontSize: 13, textAlign: "right", marginTop: 8 }}>
                {item.lastTestRelease.dateJalali}
              </div>


              {item.lastTestRelease !== undefined && item.lastTestRelease !== null && item.lastTestRelease.rollback !== undefined && item.lastTestRelease.rollback &&
                <div className="mt-2" style={{ color: "red", fontSize: 11, textAlign: "right", fontWeight: "bold" }}>
                  {rolled_back}
                </div>
              }

              {item.lastTestRelease.files !== undefined && item.lastTestRelease.files !== null && item.lastTestRelease.files.length > 0 &&
                <div className="mt-3">
                  <hr style={{ color: "gray" }} />
                  <Files
                    files={item.lastTestRelease.files}
                    title={download_it}
                    />
                </div>
              }

              {item.lastTestRelease.links !== undefined && item.lastTestRelease.links !== null && item.lastTestRelease.links.length > 0 &&
                <div className="mt-3">
                  <hr style={{ color: "gray" }} />
                  <Links
                    links={item.lastTestRelease.links}
                    title={check_it}
                  />
                </div>
              }


            </div>
          }

          {item.lastPublicRelease !== undefined && item.lastPublicRelease !== null && item.lastTestRelease !== undefined && item.lastTestRelease !== null &&
            <hr style={{ color: "gray" }} />
          }

          {item.lastPublicRelease !== undefined && item.lastPublicRelease !== null &&
            <div style={{ color: "gray", fontSize: 11, textAlign: "right" }}>
              {last_public_release}
              <span style={{ color: "black", fontSize: 12, textAlign: "right", marginRight: 5 }}>
                {item.lastPublicRelease.versionName}
              </span>
              <span style={{ marginRight: 5 }}>{in_date}</span>
              <span style={{ color: "black", fontSize: 12, textAlign: "right", marginRight: 5 }}>
                {item.lastPublicRelease.dateJalali}
              </span>
              {item.lastPublicRelease.rollback !== undefined && item.lastPublicRelease.rollback &&
                <span style={{ color: "red", fontSize: 11, textAlign: "right", marginRight: 5, fontWeight: "bold" }}>
                  {rolled_back}
                </span>
              }

              <Link target="_blank" style={{ color: "indianred", fontSize: 11, textAlign: "right", marginRight: 5, textDecoration: "none" }} className="clickable" to={"/releases/detail?i=" + item.lastPublicRelease.id}>
                {check}
              </Link>

            </div>
          }

          {(item.lastPublicRelease === undefined || item.lastPublicRelease === null) && (item.lastTestRelease === undefined || item.lastTestRelease === null) &&
            <div style={{ color: "gray", fontSize: 14, textAlign: "right" }}>
              {no_information_found}
            </div>
          }

        </div>

      </div>

    );
  }
}

export default Adapter;
